import Select from "react-select";

Select.defaultProps = {
  menuPortalTarget: document.body,
  menuPosition: "fixed",
  styles: {
    menuPortal: (base) => ({ ...base, zIndex: 9999 })
  }
};